<template>
  <draggable
    v-if="selected_journey"
    v-bind="dragOptions"
    key="id"
    v-model="selected_journey.phases"
    handle=".handle"
    filter=".ignore-elements"
    class="overflow-auto h-full mb-2"
    :group="{ name: 'phases', pull: true, put: false, revertClone: false }"
    :component-data="{ tag: 'div', type: 'transition-group' }"
    item-key="id"
    role="list"
    @change="phasesOrderChanged(selected_journey)"
    @start="drag = true"
    @end="drag = false">
    <template #item="{ element: phase }">
      <DetailedJourneyViewPhase
        v-model:expanded-phase="expanded_phase"
        :inside-component="insideComponent"
        class="bg-white rounded-lg"
        :selected-journey="selected_journey"
        :phase="phase"
        :journeys="journeys" />
    </template>
  </draggable>
</template>

<script>
import draggable from "vuedraggable"

import DetailedJourneyViewPhase from "./DetailedJourneyViewPhase.vue"
import dataService from "@/services/data.service"

export default {
  components: { DetailedJourneyViewPhase, draggable },

  props: {
    insideComponent: {
      type: Boolean,
      default: false
    },
    currentJourney: {
      type: Object,
      required: true
    },
    journeys: {
      type: Array,
      required: true
    }
  },
  emits: [],
  data() {
    return { selected_journey: null, drag: false, expanded_phase: "" }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "phases",
        disabled: false,
        ghostClass: "ghost",
        chosenClass: "chosen"
      }
    }
  },

  watch: {
    currentJourney() {
      this.selected_journey = this.currentJourney
    }
  },
  created() {
    this.selected_journey = this.currentJourney
  },

  methods: {
    phasesOrderChanged(journey) {
      dataService.updateJourney(journey.id, { phases: journey.phases.map((p) => p.id) })
    }
  }
}
</script>
